/**
 * @Author: v_jppjpeng
 * @Date: 2023-09-07 11:09:00
 * @Explain: tdesign - 定义类型声明
 */

import type { FormRule } from 'tdesign-react';

// tdesign - 表单规则
export interface TdFormRule extends FormRule {
  messageKey?: string;
}

// radio checkbox
export type RadioItemType = CommonOptionsType & {
  render?: (item: CommonOptionsType) => ReactNode;
};

export type CheckboxItemType = CommonOptionsType & {
  render?: (item: CommonOptionsType) => ReactNode;
};

// text标签
export type TextThemeType =
  | 'text'
  | 'label'
  | 'weak'
  | 'strong'
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'cost'
  | 'default';

// 排序枚举
export enum SortEnum {
  ASC = 'asc',
  DESC = 'desc',
}

/** dialog - 统一配置 */
export const commonDialogProps = {
  width: 700,
};

/** 模板预览dialog - 统一配置 */
export const commonPreviewDialogProps = {
  width: 1200,
};

/** dialog - 统一配置 */
export const dialogWidth9Props = {
  width: 1024,
};

/** dialog - 统一小宽度500 */
export const commonFormDialogProps = {
  width: 500,
  closeBtn: false,
};

/** dialog - 宽度864 */
export const dialogWidth864 = {
  width: 864,
};
